import { Injectable } from '@angular/core';
import { JobStatus } from '../../shared/models/generated/ziroModels';
import { PollingAbstractService } from '../../shared/services/abstract/polling.abstract.service';

@Injectable()
export class CdrDumpFileImportPollingContext extends PollingAbstractService<JobStatus> {
  baseUrl = '/services/cisco/reporting/cucm-cdrs/imports/dump-files/status';
}
